import {
  InputTextProps,
  InputTextComponentInnerProps,
  InputTextStyledComponentProps,
  InputTextTypes,
} from "./types"
import React from "react"
import { TextInput } from "~/ui/primitives"
import { InputTextCore } from "./core"
import styled from '~/ui/styled'

const StyledTextInput = styled(TextInput)<InputTextStyledComponentProps>`
  height: 40px;
  color: ${({ theme }) => theme.colors.text};
  padding: 5px 10px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.background};
`

export const InputTextBottomLineInnerUnrefed: React.ForwardRefRenderFunction<
  TextInput,
  InputTextComponentInnerProps
> = ({ ...rest }, ref) => {
  return <StyledTextInput {...rest} ref={ref} />
}

export const InputTextBottomLineInner = React.forwardRef(InputTextBottomLineInnerUnrefed)

const InputTextBottomLine: React.ForwardRefRenderFunction<TextInput, InputTextProps> = (
  { label, validRule, ...rest },
  ref,
) => {
  return (
    <InputTextCore
      {...rest}
      label={label}
      validRule={validRule}
      type={InputTextTypes.INPUT_TEXT_BOTTOM_LINE}
      ref={ref}
    ></InputTextCore>
  )
}

export default React.forwardRef(InputTextBottomLine)
